'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oktaDriver = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _index = require('@okta/okta-auth-js/lib/index');

var _index2 = _interopRequireDefault(_index);

var _sdk = require('@mid/sdk');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global fetch */

var jwtOrFail = _sdk.support.jwtOrFail,
    mkScopes = _sdk.support.mkScopes,
    mkScopeStr = _sdk.support.mkScopeStr,
    jwtDecode = _sdk.support.jwtDecode,
    getLoginInfo = _sdk.support.getLoginInfo;
var makeNonce = _sdk.nonce.makeNonce,
    storeNonce = _sdk.nonce.storeNonce;

/**
 * Turns an okta oidc/oauth2 endpoint into an okta baseUrl.
 * ie. https://mckidspoke1.oktapreview.com/oauth2/default/ -> https://mckidspoke1.oktapreview.com/
 *
 * @param {string|URL} domain the okta "domain"
 * @return {string} the okta baseUrl derived from the input
 */

var makeOktaBaseUrl = function makeOktaBaseUrl(domain) {
  return domain.toString().replace(/\/oauth2\/.+\/?$/, '/');
};

/**
 * Creates the url to redirect the user to for OIDC call to /authorize
 *
 * Reaches out to the oidc well-known endpoint to get the configuration
 *
 * @param {MidCore} mid The MidCore instance
 * @param {string|URL} redirectUrl the url to redirect back to when authorization is complete
 * @param {string} state any state parameter to be passed back once authorization is complete, this will be urlencoded
 * @param {string} nonce a cryptographically secure nonce, use nonceService for this
 * @param {string} email the email provided for login hinting, if null, will not br provided
 * @param {[string]} scopes scopes requested
 * @param {LoginInfo} loginInfo the Tenant's configuration
 * @return {Promise<URL>} the url to redirect to
 * @throws {Error} if the nonce is not provided, or if the OIDC fetch fails
 */
var makeOidcAuthorizeUrl = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(mid, redirectUrl, state, nonce, email, scopes, loginInfo) {
    var rs, _ref2, authorization_endpoint, url;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (nonce) {
              _context.next = 2;
              break;
            }

            throw new Error(mid.errors.ERR_MISCONFIGURATION('Nonce must be provided'));

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return fetch(loginInfo.oidcConfigUrl.toString());

          case 5:
            rs = _context.sent;
            _context.next = 8;
            return rs.json();

          case 8:
            _ref2 = _context.sent;
            authorization_endpoint = _ref2.authorization_endpoint;


            // eslint-disable-next-line camelcase
            url = new URL(authorization_endpoint);

            url.searchParams.append('client_id', loginInfo.appId);
            url.searchParams.append('redirect_uri', redirectUrl.toString());

            url.searchParams.append('scope', mkScopeStr(scopes));

            if (state) {
              url.searchParams.append('state', state);
            } else {
              url.searchParams.append('state', '.');
            }

            url.searchParams.append('response_type', 'id_token token');

            url.searchParams.append('nonce', nonce);

            if (email) {
              url.searchParams.append('login_hint', email);
            }

            return _context.abrupt('return', url);

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](2);
            throw new Error(mid.errors.FAIL_RETR_METADATA('Unable to retrieve OIDC metadata'));

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[2, 21]]);
  }));

  return function makeOidcAuthorizeUrl(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();

var makeOidcUserInfoUrl = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(mid, tenantConfig) {
    var rs, _ref4, userinfo_endpoint, url;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(tenantConfig.oidcConfigUrl);

          case 3:
            rs = _context2.sent;
            _context2.next = 6;
            return rs.json();

          case 6:
            _ref4 = _context2.sent;
            userinfo_endpoint = _ref4.userinfo_endpoint;

            if (userinfo_endpoint) {
              _context2.next = 10;
              break;
            }

            throw new Error(mid.errors.FAIL_RETR_METADATA('Unable to find userinfo endpoint from OIDC config'));

          case 10:
            url = new URL(userinfo_endpoint);
            return _context2.abrupt('return', url);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2['catch'](0);
            throw new Error(mid.errors.FAIL_RETR_METADATA('Unable to retrieve OIDC metadata'));

          case 17:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 14]]);
  }));

  return function makeOidcUserInfoUrl(_x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 *
 * @type {AuthDriver}
 */
var oktaDriver = exports.oktaDriver = {
  /**
   * Log the user out
   *
   * @param {Mid} mid the McKinsey ID Object
   * @param {LoginInfo} loginInfo - the login information
   * @return {Promise<void>} void
   */
  logout: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(mid, loginInfo) {
      var rs, _ref6, end_session_endpoint, revocation_endpoint, logoutUrl, revocationUrl, revocationBody;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!loginInfo.oidcConfigUrl) {
                _context3.next = 28;
                break;
              }

              _context3.next = 3;
              return fetch(loginInfo.oidcConfigUrl.toString());

            case 3:
              rs = _context3.sent;
              _context3.next = 6;
              return rs.json();

            case 6:
              _ref6 = _context3.sent;
              end_session_endpoint = _ref6.end_session_endpoint;
              revocation_endpoint = _ref6.revocation_endpoint;

              if (!jwtOrFail(mid.idToken())) {
                _context3.next = 20;
                break;
              }

              // eslint-disable-next-line camelcase
              logoutUrl = new URL(end_session_endpoint);


              logoutUrl.searchParams.append('id_token_hint', mid.idToken());
              logoutUrl.searchParams.append('post_logout_redirect_uri', mid.logoutRedirectUrl.toString());

              _context3.prev = 13;
              _context3.next = 16;
              return fetch(logoutUrl.toString(), { credentials: 'include', mode: 'no-cors' });

            case 16:
              _context3.next = 20;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3['catch'](13);

            case 20:
              if (!jwtOrFail(mid.accessToken())) {
                _context3.next = 28;
                break;
              }

              // eslint-disable-next-line camelcase
              revocationUrl = new URL(revocation_endpoint);
              revocationBody = new URLSearchParams();

              revocationBody.append('client_id', loginInfo.appId);
              revocationBody.append('token', mid.accessToken());
              revocationBody.append('token_type_hint', 'access_token');

              // there's not much we can do here if the revocation fails. so just keep going (ie. ignore promise)
              _context3.next = 28;
              return fetch(revocationUrl.toString(), {
                method: 'POST',
                body: revocationBody.toString(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
              });

            case 28:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[13, 18]]);
    }));

    function logout(_x10, _x11) {
      return _ref5.apply(this, arguments);
    }

    return logout;
  }(),

  /**
   * Apply forgot password logic for the hosted page
   * @param {string} email the email to issue a forgot password for
   * @param {string|URL} redirectUrl the url to redirect to
   * @param {LoginInfo} loginInfo - the login information
   * @return {Promise<void>} suspends until the forgot password command is issued
   */
  hostedForgotPassword: function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(email, redirectUrl, loginInfo) {
      var authClient, txn;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              authClient = new _index2.default({
                url: makeOktaBaseUrl(loginInfo.domain),
                redirectUri: redirectUrl.toString()
              });
              _context4.next = 4;
              return authClient.forgotPassword({
                username: email,
                factorType: 'EMAIL'
              });

            case 4:
              txn = _context4.sent;

              if (!(txn.status !== 'SUCCESS')) {
                _context4.next = 7;
                break;
              }

              throw new Error('Unhandled transaction status ' + txn.status);

            case 7:
              _context4.next = 13;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4['catch'](0);

              console.error('failure during okta forgot password flow', _context4.t0);
              throw new Error(_sdk.errors.ERR_INVALID_REQUEST_IDP());

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[0, 9]]);
    }));

    function hostedForgotPassword(_x12, _x13, _x14) {
      return _ref7.apply(this, arguments);
    }

    return hostedForgotPassword;
  }(),

  /**
   * Success/Error states are defined by https://github.com/okta/okta-auth-js#transactionstatus
   * @param {MidCore} mid The MidCore instance
   * @param {string|URL} redirectUrl the redirect url for this solution
   * @param {string} email the email address of the credential
   * @param {string} password the password for the credential
   * @param {[string]} scopes the requested scopes
   * @param {LoginInfo} loginInfo the login information
   * @return {Promise<void>} suspends until the login is complete
   */
  hostedLogin: function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(mid, redirectUrl, email, password, scopes, loginInfo) {
      var nonce, authClient, rs, status, sessionToken, response;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              nonce = makeNonce();

              storeNonce(nonce);

              _context5.prev = 2;
              authClient = new _index2.default({
                url: makeOktaBaseUrl(loginInfo.domain),
                issuer: loginInfo.domain.toString(),
                redirectUri: redirectUrl.toString(),
                clientId: loginInfo.appId
              });
              _context5.next = 6;
              return authClient.signIn({
                username: email,
                password: password
              });

            case 6:
              rs = _context5.sent;
              status = rs.status, sessionToken = rs.sessionToken;
              _context5.t0 = status.toUpperCase();
              _context5.next = _context5.t0 === 'PASSWORD_WARN' ? 11 : _context5.t0 === 'SUCCESS' ? 12 : _context5.t0 === 'LOCKED_OUT' ? 20 : _context5.t0 === 'PASSWORD_EXPIRED' ? 21 : 22;
              break;

            case 11:
              console.warn('user password about to expire');

            case 12:
              _context5.next = 14;
              return authClient.token.getWithoutPrompt({
                responseType: ['id_token', 'token'],
                sessionToken: sessionToken,
                scopes: mkScopes(scopes),
                nonce: nonce
              });

            case 14:
              response = _context5.sent;


              mid.setLoginInfo(loginInfo);
              _context5.next = 18;
              return mid.setTokens(response[0].idToken, response[1].accessToken);

            case 18:
              mid.onLoginResolve();
              return _context5.abrupt('break', 23);

            case 20:
              throw new Error(mid.errors.FAIL_USER_LOCKOUT());

            case 21:
              throw new Error(mid.errors.FAIL_PASSWD_EXPIRE());

            case 22:
              throw new Error(mid.errors.ERR_UNHANDLED('McK/ID currently doesn\'t handle the Okta status ' + status));

            case 23:
              _context5.next = 29;
              break;

            case 25:
              _context5.prev = 25;
              _context5.t1 = _context5['catch'](2);

              console.error('failure during okta auth', _context5.t1);
              throw _context5.t1;

            case 29:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, undefined, [[2, 25]]);
    }));

    function hostedLogin(_x15, _x16, _x17, _x18, _x19, _x20) {
      return _ref8.apply(this, arguments);
    }

    return hostedLogin;
  }(),

  /**
   * Redirect to the IdP credential entry page
   *
   * @param {MidCore} midCore - the MidCore instance
   * @param {string|URL} redirectUrl - the url to redirect to
   * @param {string|null} state - any state parameter to pass to the login
   * @param {string} email - the email to login with
   * @param {[string]} scopes - the set of oauth2 scopes
   * @param {LoginInfo} loginInfo - the login information
   *
   * @return {Promise<void>} - an async that suspends until the redirect happens
   */
  redirectLogin: function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(midCore, redirectUrl, state, email, scopes, loginInfo) {
      var nonce;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              nonce = makeNonce();

              storeNonce(nonce);

              if (!getLoginInfo()) {
                midCore.setLoginInfo(loginInfo);
              }

              _context6.next = 5;
              return makeOidcAuthorizeUrl(midCore, redirectUrl, state, nonce, email, scopes, loginInfo);

            case 5:
              window.location = _context6.sent;

            case 6:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, undefined);
    }));

    function redirectLogin(_x21, _x22, _x23, _x24, _x25, _x26) {
      return _ref9.apply(this, arguments);
    }

    return redirectLogin;
  }(),

  /**
   * Refresh a token. Only supports implicit flow for now.
   *
   * @param {MidCore} midCore - the MidCore instance
   * @param {string|URL} redirectUrl - the redirectUrl for this solution
   * @param {[string]} scopes - the scopes
   * @param {LoginInfo} loginInfo - the login information
   * @return {Promise<void>} - stalls until the token has been refreshed
   */
  refresh: function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(midCore, redirectUrl, scopes, loginInfo) {
      var authClient, session, response;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              authClient = new _index2.default({
                url: makeOktaBaseUrl(loginInfo.domain),
                clientId: loginInfo.appId,
                redirectUri: redirectUrl.toString(),
                issuer: loginInfo.domain.toString()
              });
              _context7.prev = 1;
              _context7.next = 4;
              return authClient.session.refresh();

            case 4:
              session = _context7.sent;
              _context7.next = 7;
              return authClient.token.getWithoutPrompt({
                responseType: ['id_token', 'token'],
                sessionToken: session,
                scopes: mkScopes(scopes)
              });

            case 7:
              response = _context7.sent;
              _context7.next = 10;
              return midCore.setTokens(response[0].idToken, response[1].accessToken);

            case 10:
              _context7.next = 22;
              break;

            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7['catch'](1);

              if (!(_context7.t0.errorCode && _context7.t0.errorCode === 'E0000007')) {
                _context7.next = 19;
                break;
              }

              _context7.next = 17;
              return midCore.logout();

            case 17:
              _context7.next = 22;
              break;

            case 19:
              console.error(midCore.errors.ERR_UNHANDLED('Error during refresh'), _context7.t0);
              _context7.next = 22;
              return midCore.logout();

            case 22:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, undefined, [[1, 12]]);
    }));

    function refresh(_x27, _x28, _x29, _x30) {
      return _ref10.apply(this, arguments);
    }

    return refresh;
  }(),

  /**
   * Attempt an SSO
   *
   * @param {MidCore} midCore - the Mid core instance
   * @param {LoginInfo} loginInfo - the login information
   * @return {Promise<void>} - suspends until sso is attempted
   */
  attemptSSO: function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(midCore, loginInfo) {
      var idToken, accessToken;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // override any tenant configuration in the browser/reset it if it's gone
              midCore.setLoginInfo(loginInfo);

              _context8.next = 3;
              return oktaDriver.refresh(midCore, midCore.redirectUrl, midCore.scopes, loginInfo);

            case 3:
              idToken = midCore.idToken();
              accessToken = midCore.accessToken();


              if (!!accessToken) {
                midCore.state = midCore.state.set(_sdk.PHASE, _sdk.ST.TENANT_FETCH).set(_sdk.DATA, {
                  idToken: idToken,
                  accessToken: accessToken,
                  loginInfo: loginInfo
                }).remove(_sdk.ERROR_MSG);
              }

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, undefined);
    }));

    function attemptSSO(_x31, _x32) {
      return _ref11.apply(this, arguments);
    }

    return attemptSSO;
  }(),

  /**
   * On landing, process any potential errors the IdP responded with
   *
   * @param {MidCore} midCore - The Mid core instance
   * @param {object} params - the query parameters
   * @param {LoginInfo} loginInfo - the login information
   * @returns {void} - nothing
   * @throws Error - if there's a problem with the params
   */
  redirectLanding: function redirectLanding(midCore, params, loginInfo) {
    if (!params) {
      throw new Error('No valid landing parameters found');
    }

    if (params.error) {
      switch (params.error) {
        case 'access_denied':
          throw new Error(midCore.errors.FAIL_CREDENTIALS('Access is Denied'));
        case 'invalid_client':
        case 'invalid_grant':
        case 'invalid_request':
        case 'invalid_scope':
        case 'invalid_token':
        case 'unsupported_response_type':
        case 'unsupported_response_mode':
          throw new Error(midCore.errors.ERR_MISCONFIGURATION('Failed due to ' + params.error));
        case 'server_error':
          throw new Error(midCore.errors.ERR_UNHANDLED('Server Error'));
        case 'temporarily_unavailable':
          throw new Error(midCore.errors.FAIL_TEMP('Sign in is temporarily unavailable. Please try later.'));
        default:
          throw new Error(midCore.errors.ERR_UNHANDLED('Error code ' + params.error));
      }
    }
  },

  /**
   * Get user info
   *
   * @param {MidCore} midCore - the internal Mid Object
   * @param {tenant} tenant configuration
   * @return {userInfo} - user information
   */
  userInfo: function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(midCore, tenant) {
      var userInfoUrl, response, user;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return makeOidcUserInfoUrl(midCore, tenant);

            case 3:
              userInfoUrl = _context9.sent;
              _context9.next = 6;
              return fetch(userInfoUrl.toString(), {
                headers: { Authorization: 'Bearer ' + midCore.accessToken() }
              });

            case 6:
              response = _context9.sent;

              if (response.ok) {
                _context9.next = 9;
                break;
              }

              throw new Error(midCore.errors.ERR_UNHANDLED('Error during fetch okta userInfo'));

            case 9:
              ;
              _context9.next = 12;
              return response.json();

            case 12:
              user = _context9.sent;
              return _context9.abrupt('return', user);

            case 16:
              _context9.prev = 16;
              _context9.t0 = _context9['catch'](0);

              console.error(midCore.errors.ERR_UNHANDLED('Error during okta userInfo'), _context9.t0);

            case 19:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, undefined, [[0, 16]]);
    }));

    function userInfo(_x33, _x34) {
      return _ref12.apply(this, arguments);
    }

    return userInfo;
  }(),

  /**
   * Verifies the tokens for a login
   *
   * @param {MidCore} mid - the mid core instance
   * @param {LoginInfo} loginInfo - the login information to verify the tokens from
   * @param {{string: string}} tokens - the token map, token type -> token data
   * @return {Promise<string>} - returns an array or error messages if any thing failed
   */
  verifyTokens: function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(mid, loginInfo, tokens) {
      var errs, rs, _ref14, introspection_endpoint, verifiers;

      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              errs = [];
              _context11.prev = 1;

              if (tokens) {
                _context11.next = 4;
                break;
              }

              throw new Error(mid.errors.ERR_UNHANDLED('No tokens provided for verification'));

            case 4:
              _context11.next = 6;
              return fetch(loginInfo.oidcConfigUrl.toString());

            case 6:
              rs = _context11.sent;
              _context11.next = 9;
              return rs.json();

            case 9:
              _ref14 = _context11.sent;
              introspection_endpoint = _ref14.introspection_endpoint;
              verifiers = Object.entries(tokens).map(function () {
                var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref15) {
                  var _ref17 = _slicedToArray(_ref15, 2),
                      tokenType = _ref17[0],
                      token = _ref17[1];

                  var url, body, tokenRs, verifyJson;
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          url = new URL(introspection_endpoint);
                          body = new URLSearchParams();

                          body.append('client_id', loginInfo.appId);
                          body.append('token', token);
                          body.append('token_type_hint', tokenType);

                          _context10.next = 7;
                          return fetch(url, { method: 'post', body: body });

                        case 7:
                          tokenRs = _context10.sent;

                          if (tokenRs.ok) {
                            _context10.next = 11;
                            break;
                          }

                          errs.push('Failed to verify ' + tokenType);
                          return _context10.abrupt('return');

                        case 11:
                          _context10.next = 13;
                          return tokenRs.json();

                        case 13:
                          verifyJson = _context10.sent;

                          if (!!!verifyJson.active) {
                            errs.push(tokenType + ' is not active');
                          }

                        case 15:
                        case 'end':
                          return _context10.stop();
                      }
                    }
                  }, _callee10, undefined);
                }));

                return function (_x38) {
                  return _ref16.apply(this, arguments);
                };
              }());
              _context11.next = 14;
              return Promise.all(verifiers);

            case 14:
              if (!(errs.length > 0)) {
                _context11.next = 16;
                break;
              }

              throw new Error(mid.errors.FAIL_RETR_METADATA(errs.join(',')));

            case 16:
              _context11.next = 22;
              break;

            case 18:
              _context11.prev = 18;
              _context11.t0 = _context11['catch'](1);

              console.error(_context11.t0);
              throw _context11.t0;

            case 22:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, undefined, [[1, 18]]);
    }));

    function verifyTokens(_x35, _x36, _x37) {
      return _ref13.apply(this, arguments);
    }

    return verifyTokens;
  }(),

  /**
   * Get login email
   *
   * @param {MidCore} mid - the mid core instance
   * @param {LoginInfo} loginInfo - the login information to verify the tokens from
   * @return {Promise<string>} - returns login email
   */
  email: function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(mid, loginInfo) {
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              return _context12.abrupt('return', jwtDecode(mid.accessToken()).sub);

            case 4:
              _context12.prev = 4;
              _context12.t0 = _context12['catch'](0);

              console.error(mid.errors.ERR_UNHANDLED('Error during okta get email'), _context12.t0);

            case 7:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, undefined, [[0, 4]]);
    }));

    function email(_x39, _x40) {
      return _ref18.apply(this, arguments);
    }

    return email;
  }()
};